import { Text } from "./../Typography";
import { Maybe } from "../../generated/graphql";
import { Dots } from "./styles";

export const FileInfo = ({ size, mimeType, width, height }: { size?: Maybe<number> | undefined, mimeType?: Maybe<string>, width?: Maybe<number> | undefined, height?: Maybe<number> | undefined }) => {
  const fileType = mimeType?.substring(mimeType?.indexOf('/') + 1);
  const sizeInMB = Number((size || 1) / 1000000).toFixed(2);
  const hasDimensions = width !== undefined && height !== undefined && width !== null && height !== null && !isNaN(width) && !isNaN(height) && width > 0 && height > 0;
  return <Text type="lead" tag="p" className="mb-1">{fileType} <Dots /> {sizeInMB} MB{hasDimensions && <> <Dots /> {width} x {height}px</>}</Text>;
}